import(/* webpackMode: "eager" */ "/app/frontend/src/app/(auth)/register/page.tsx");
